import { AnyObject, SkipOrArgs } from '@common/types/queryState';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { TypedUseQueryHookResult } from '@reduxjs/toolkit/query/react';

type RTKQueryHook<Response, Args> = (
    args: SkipOrArgs<Args>,
    options?: AnyObject,
) => TypedUseQueryHookResult<Response, SkipOrArgs<Args>, BaseQueryFn>;

export const useApiQuery = <Response, Args>(
    useRTKHook: RTKQueryHook<Response, Args>,
    args: SkipOrArgs<Args>,
    options?: AnyObject,
) => {
    return useRTKHook(args, options);
};

export type UseApiQueryArgs<Response, Args extends AnyObject> = Parameters<
    typeof useApiQuery<Response, Args>
>;
export type UseApiQueryResult<Response, Args extends AnyObject> = ReturnType<
    typeof useApiQuery<Response, Args>
>;
